import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { QueryParams } from '../../collection/collection.model';
import { Filter } from '../filter.model';
import { FilterLayout } from "../../../../../../../api/src/data-source/models/filter.model";
import { createFormGroup } from "../filter.utils";
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-filter-bar',
  templateUrl:
  './filter-bar.component.html',
  styleUrls: ['./filter-bar.component.scss']
})
export class FilterBarComponent implements OnInit, OnChanges, OnDestroy {
	@Input() filters: Filter[];
	@Input() queryParams: QueryParams;
	@Input() filterLayout: 'horizontal' | 'vertical' = 'horizontal';
	@Input() showSidebarToggle = false;
	@Input() showSearch: boolean = true;

	@Output() update: EventEmitter<QueryParams> = new EventEmitter();
	@Output() reset: EventEmitter<string> = new EventEmitter();
	@Output() toggleSidebar: EventEmitter<void> = new EventEmitter();

	public form: UntypedFormGroup;
	public relevantFilters: Filter[];
	private destroy$ = new Subject<void>();

	constructor(
		private readonly fb: UntypedFormBuilder
	) {}

	ngOnInit(): void {
		this.relevantFilters = this.getRelevantFilters();
	}

	ngOnChanges(changes: SimpleChanges) {
		if (!this.form) {
			this.form = this.fb.group(createFormGroup(this.filters));
			this.form.valueChanges.pipe(takeUntil(this.destroy$)).subscribe((values => this.update.emit(values)));

		} else if (changes.filters) {
			this.relevantFilters = this.getRelevantFilters();
		}

		this.form.patchValue({ ...this.queryParams }, { emitEvent: false });
	}

	private getRelevantFilters() {
		if (this.filterLayout === FilterLayout.Horizontal) {
			return this.filters.filter(f => f.layout !== FilterLayout.Vertical);
		} else {
			return this.filters.filter(f => f.layout === FilterLayout.Vertical);
		}
	}

	updateQueryParam(key: string | object) {
		// date-range component returns an object with two form control values
		if (typeof key === 'object') {
			this.update.emit(key);
		} else {
			this.update.emit({
				[key]: this.form.get(key)?.value
			});
		}
	}

	trackByFn(index, item) {
		return item.id;
	}

	ngOnDestroy(): void {
		this.destroy$.next();
		this.destroy$.complete();
	}
}
